"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TessasAscensionAbilityHandler = exports.TessasAscensionActorAbilityFactory = exports.TessasAscensionAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class TessasAscensionAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TessasAscension;
        this.__typeName = "TessasAscension";
    }
}
exports.TessasAscensionAbilityArgs = TessasAscensionAbilityArgs;
let TessasAscensionActorAbilityFactory = class TessasAscensionActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TessasAscension", "OneAllies", 4);
    }
};
TessasAscensionActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TessasAscension")
], TessasAscensionActorAbilityFactory);
exports.TessasAscensionActorAbilityFactory = TessasAscensionActorAbilityFactory;
let TessasAscensionAbilityHandler = class TessasAscensionAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAllyOrSelf] = ability.args.target.actorIds;
        const will = container.getAttributeScore(ability.invokerId, AttributeType_1.AttributeType.Will);
        sequence.push(new core_2.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "TessasAscension", "casting"));
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: selectedAllyOrSelf,
            duration: Duration_1.Duration.Turns(4),
            effect: new core_1.LinkedEffectsEffectArgs([
                new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(selectedAllyOrSelf, 10, "Focus")),
                new core_1.HasteEffectArgs(2),
            ], false),
            onApplied: (sequence) => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAllyOrSelf, "chest"), "PinkGlyph"));
            }
        });
    }
};
TessasAscensionAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TessasAscension)
], TessasAscensionAbilityHandler);
exports.TessasAscensionAbilityHandler = TessasAscensionAbilityHandler;
